import { defineMessages } from "react-intl";

import {
    USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE,
    USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE,
    USER_SEGMENTATION_TEAM_TYPE_DESIGN,
    USER_SEGMENTATION_TEAM_TYPE_FINANCE,
    USER_SEGMENTATION_TEAM_TYPE_HR,
    USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
    USER_SEGMENTATION_TEAM_TYPE_LEGAL,
    USER_SEGMENTATION_TEAM_TYPE_MARKETING,
    USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
    USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
    USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_SALES,
    USER_SEGMENTATION_TEAM_TYPE_SOFTWARE
} from "@atlassian/onboarding-survey";

export const stepMessages = defineMessages({
    header: {
        id: "step.madlib.header",
        defaultMessage: "What are you working on?"
    },
    subheader: {
        id: "step.madlib.subheader",
        defaultMessage:
            "Share what you’re working on, and we’ll turn it into actionable tasks so your team can get started faster."
    },
    submitButton: {
        id: "step.madlib.submitButton",
        defaultMessage: "Create space"
    },
    skipButton: {
        id: "step.madlib.skipButton",
        defaultMessage: "Skip"
    },
    aiDisclaimer: {
        id: "step.madlib.aiDisclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    aiDisclaimerLabel: {
        id: "step.madlib.aiDisclaimerLabel",
        defaultMessage: "AI Disclaimer Information Icon"
    },
    aiDisclaimerLinkNewWindowLabel: {
        id: "step.madlib.aiDisclaimerLinkNewWindowLabel",
        defaultMessage: "Opens a new window to view AI information"
    }
});

// TEAM TYPE => Software Development
export const suggestion1Message = defineMessages({
    content: {
        id: "suggestion.1.madlib.content",
        defaultMessage:
            "Feature release with the goal of meeting a key user need",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.1.madlib.task",
        defaultMessage: "feature release",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.1.madlib.goal",
        defaultMessage: "meeting a key user need",
        description: "The goal for the suggestion"
    }
});

export const suggestion2Message = defineMessages({
    content: {
        id: "suggestion.2.madlib.content",
        defaultMessage:
            "Platform migration with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.2.madlib.task",
        defaultMessage: "platform migration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.2.madlib.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});

export const suggestion3Messages = defineMessages({
    content: {
        id: "suggestion.3.madlib.content",
        defaultMessage:
            "Backend revamp with the goal of improving system performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.3.madlib.task",
        defaultMessage: "backend revamp",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.3.madlib.goal",
        defaultMessage: "improving system performance",
        description: "The goal for the suggestion"
    }
});

export const suggestion4Messages = defineMessages({
    content: {
        id: "suggestion.4.madlib.content",
        defaultMessage:
            "Design system update with the goal of unifying components",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.4.madlib.task",
        defaultMessage: "design system update",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.4.madlib.goal",
        defaultMessage: "unifying components",
        description: "The goal for the suggestion"
    }
});

export const suggestion5Messages = defineMessages({
    content: {
        id: "suggestion.5.madlib.content",
        defaultMessage:
            "API integration project with the goal of connecting new services",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.5.madlib.task",
        defaultMessage: "api integration project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.5.madlib.goal",
        defaultMessage: "connecting new services",
        description: "The goal for the suggestion"
    }
});

export const suggestion6Messages = defineMessages({
    content: {
        id: "suggestion.6.madlib.content",
        defaultMessage:
            "Mobile app launch with the goal of delivering a responsive design",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.6.madlib.task",
        defaultMessage: "mobile app launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.6.madlib.goal",
        defaultMessage: "delivering a responsive design",
        description: "The goal for the suggestion"
    }
});

export const suggestion7Messages = defineMessages({
    content: {
        id: "suggestion.7.madlib.content",
        defaultMessage:
            "Security fix with the goal of resolving vulnerabilities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.7.madlib.task",
        defaultMessage: "security fix",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.7.madlib.goal",
        defaultMessage: "resolving vulnerabilities",
        description: "The goal for the suggestion"
    }
});

export const suggestion8Messages = defineMessages({
    content: {
        id: "suggestion.8.madlib.content",
        defaultMessage:
            "Performance optimization with the goal of speeding up the app",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.8.madlib.task",
        defaultMessage: "performance optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.8.madlib.goal",
        defaultMessage: "speeding up the app",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => Product Management
export const suggestion9Messages = defineMessages({
    content: {
        id: "suggestion.9.madlib.content",
        defaultMessage:
            "Product launch with the goal of shipping a new service to market",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.9.madlib.task",
        defaultMessage: "product launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.9.madlib.goal",
        defaultMessage: "shipping a new service to market",
        description: "The goal for the suggestion"
    }
});

export const suggestion10Messages = defineMessages({
    content: {
        id: "suggestion.10.madlib.content",
        defaultMessage:
            "Feature launch with the goal of delivering value to users",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.10.madlib.task",
        defaultMessage: "feature launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.10.madlib.goal",
        defaultMessage: "delivering value to users",
        description: "The goal for the suggestion"
    }
});

export const suggestion11Messages = defineMessages({
    content: {
        id: "suggestion.11.madlib.content",
        defaultMessage:
            "Strategic plan with the goal of creating a clear roadmap",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.11.madlib.task",
        defaultMessage: "strategic plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.11.madlib.goal",
        defaultMessage: "creating a clear roadmap",
        description: "The goal for the suggestion"
    }
});

export const suggestion12Messages = defineMessages({
    content: {
        id: "suggestion.12.madlib.content",
        defaultMessage:
            "Customer research study with the goal of gathering insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.12.madlib.task",
        defaultMessage: "customer research study",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.12.madlib.goal",
        defaultMessage: "gathering insights",
        description: "The goal for the suggestion"
    }
});

export const suggestion13Messages = defineMessages({
    content: {
        id: "suggestion.13.madlib.content",
        defaultMessage:
            "Platform upgrade with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.13.madlib.task",
        defaultMessage: "platform upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.13.madlib.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});

export const suggestion14Messages = defineMessages({
    content: {
        id: "suggestion.14.madlib.content",
        defaultMessage:
            "Analytics project with the goal of tracking key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.14.madlib.task",
        defaultMessage: "analytics project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.14.madlib.goal",
        defaultMessage: "tracking key metrics",
        description: "The goal for the suggestion"
    }
});

export const suggestion15Messages = defineMessages({
    content: {
        id: "suggestion.15.madlib.content",
        defaultMessage:
            "Quarterly product plan with the goal of creating a strong backlog",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.15.madlib.task",
        defaultMessage: "quarterly product plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.15.madlib.goal",
        defaultMessage: "creating a strong backlog",
        description: "The goal for the suggestion"
    }
});

export const suggestion16Messages = defineMessages({
    content: {
        id: "suggestion.16.madlib.content",
        defaultMessage:
            "A/B experiment with the goal of optimizing an experience",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.16.madlib.task",
        defaultMessage: "a/b experiment",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.16.madlib.goal",
        defaultMessage: "optimizing an experience",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => MARKETING
export const suggestion17Messages = defineMessages({
    content: {
        id: "suggestion.17.madlib.content",
        defaultMessage:
            "Campaign launch with the goal of driving brand awareness",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.17.madlib.task",
        defaultMessage: "campaign launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.17.madlib.goal",
        defaultMessage: "driving brand awareness",
        description: "The goal for the suggestion"
    }
});

export const suggestion18Messages = defineMessages({
    content: {
        id: "suggestion.18.madlib.content",
        defaultMessage: "Content strategy with the goal of improving SEO",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.18.madlib.task",
        defaultMessage: "content strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.18.madlib.goal",
        defaultMessage: "improving SEO",
        description: "The goal for the suggestion"
    }
});

export const suggestion19Messages = defineMessages({
    content: {
        id: "suggestion.19.madlib.content",
        defaultMessage:
            "Referral program with the goal of growing customers via referrals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.19.madlib.task",
        defaultMessage: "referral program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.19.madlib.goal",
        defaultMessage: "growing customers via referrals",
        description: "The goal for the suggestion"
    }
});

export const suggestion20Messages = defineMessages({
    content: {
        id: "suggestion.20.madlib.content",
        defaultMessage:
            "Social media campaign with the goal of increasing engagement",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.20.madlib.task",
        defaultMessage: "social media campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.20.madlib.goal",
        defaultMessage: "increasing engagement",
        description: "The goal for the suggestion"
    }
});

export const suggestion21Messages = defineMessages({
    content: {
        id: "suggestion.21.madlib.content",
        defaultMessage:
            "Influencer partnership with the goal of reaching new audiences",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.21.madlib.task",
        defaultMessage: "influencer partnership",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.21.madlib.goal",
        defaultMessage: "reaching new audiences",
        description: "The goal for the suggestion"
    }
});

export const suggestion22Messages = defineMessages({
    content: {
        id: "suggestion.22.madlib.content",
        defaultMessage:
            "Promotional event with the goal of driving brand awareness",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.22.madlib.task",
        defaultMessage: "promotional event",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.22.madlib.goal",
        defaultMessage: "driving brand awareness",
        description: "The goal for the suggestion"
    }
});

export const suggestion23Messages = defineMessages({
    content: {
        id: "suggestion.23.madlib.content",
        defaultMessage: "Email campaign with the goal of generating leads",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.23.madlib.task",
        defaultMessage: "email campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.23.madlib.goal",
        defaultMessage: "generating leads",
        description: "The goal for the suggestion"
    }
});

export const suggestion24Messages = defineMessages({
    content: {
        id: "suggestion.24.madlib.content",
        defaultMessage:
            "Paid advertising with the goal of reaching new customers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.24.madlib.task",
        defaultMessage: "paid advertising",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.24.madlib.goal",
        defaultMessage: "reaching new customers",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => OTHER
export const suggestion25Messages = defineMessages({
    content: {
        id: "suggestion.25.madlib.content",
        defaultMessage:
            "Cross-team launch with the goal of delivering a new service",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.25.madlib.task",
        defaultMessage: "cross-team launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.25.madlib.goal",
        defaultMessage: "delivering a new service",
        description: "The goal for the suggestion"
    }
});

export const suggestion26Messages = defineMessages({
    content: {
        id: "suggestion.26.madlib.content",
        defaultMessage: "System upgrade with the goal of improving performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.26.madlib.task",
        defaultMessage: "system upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.26.madlib.goal",
        defaultMessage: "improving performance",
        description: "The goal for the suggestion"
    }
});

export const suggestion27Messages = defineMessages({
    content: {
        id: "suggestion.27.madlib.content",
        defaultMessage:
            "Training program with the goal of upskilling team members",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.27.madlib.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.27.madlib.goal",
        defaultMessage: "upskilling team members",
        description: "The goal for the suggestion"
    }
});

export const suggestion28Messages = defineMessages({
    content: {
        id: "suggestion.28.madlib.content",
        defaultMessage:
            "Communication strategy with the goal of aligning stakeholders",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.28.madlib.task",
        defaultMessage: "communication strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.28.madlib.goal",
        defaultMessage: "aligning stakeholders",
        description: "The goal for the suggestion"
    }
});

export const suggestion29Messages = defineMessages({
    content: {
        id: "suggestion.29.madlib.content",
        defaultMessage:
            "Event planning initiative with the goal of engaging participants",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.29.madlib.task",
        defaultMessage: "event planning initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.29.madlib.goal",
        defaultMessage: "engaging participants",
        description: "The goal for the suggestion"
    }
});

export const suggestion30Messages = defineMessages({
    content: {
        id: "suggestion.30.madlib.content",
        defaultMessage:
            "Process optimization project with the goal of increasing efficiency",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.30.madlib.task",
        defaultMessage: "process optimization project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.30.madlib.goal",
        defaultMessage: "increasing efficiency",
        description: "The goal for the suggestion"
    }
});

export const suggestion31Messages = defineMessages({
    content: {
        id: "suggestion.31.madlib.content",
        defaultMessage:
            "Company-wide initiative with the goal of improving collaboration",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.31.madlib.task",
        defaultMessage: "company-wide initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.31.madlib.goal",
        defaultMessage: "improving collaboration",
        description: "The goal for the suggestion"
    }
});

export const suggestion32Messages = defineMessages({
    content: {
        id: "suggestion.32.madlib.content",
        defaultMessage:
            "Technology upgrade with the goal of modernizing our tools",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.32.madlib.task",
        defaultMessage: "technology upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.32.madlib.goal",
        defaultMessage: "modernizing our tools",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => DATA SCIENCE
export const suggestion33Messages = defineMessages({
    content: {
        id: "suggestion.33.madlib.content",
        defaultMessage: "Dashboard with the goal of tracking performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.33.madlib.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.33.madlib.goal",
        defaultMessage: "tracking performance",
        description: "The goal for the suggestion"
    }
});

export const suggestion34Messages = defineMessages({
    content: {
        id: "suggestion.34.madlib.content",
        defaultMessage:
            "Segmentation model with the goal of driving personalization",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.34.madlib.task",
        defaultMessage: "segmentation model",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.34.madlib.goal",
        defaultMessage: "driving personalization",
        description: "The goal for the suggestion"
    }
});

export const suggestion35Messages = defineMessages({
    content: {
        id: "suggestion.35.madlib.content",
        defaultMessage: "Predictive model with the goal of forecasting demand",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.35.madlib.task",
        defaultMessage: "predictive model",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.35.madlib.goal",
        defaultMessage: "forecasting demand",
        description: "The goal for the suggestion"
    }
});

export const suggestion36Messages = defineMessages({
    content: {
        id: "suggestion.36.madlib.content",
        defaultMessage:
            "A/B test analysis with the goal of measuring experiment impact",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.36.madlib.task",
        defaultMessage: "a/b test analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.36.madlib.goal",
        defaultMessage: "measuring experiment impact",
        description: "The goal for the suggestion"
    }
});

export const suggestion37Messages = defineMessages({
    content: {
        id: "suggestion.37.madlib.content",
        defaultMessage:
            "Churn analysis with the goal of reducing customer loss",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.37.madlib.task",
        defaultMessage: "churn analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.37.madlib.goal",
        defaultMessage: "reducing customer loss",
        description: "The goal for the suggestion"
    }
});

export const suggestion38Messages = defineMessages({
    content: {
        id: "suggestion.38.madlib.content",
        defaultMessage: "Data pipeline with the goal of improving data quality",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.38.madlib.task",
        defaultMessage: "data pipeline",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.38.madlib.goal",
        defaultMessage: "improving data quality",
        description: "The goal for the suggestion"
    }
});

export const suggestion39Messages = defineMessages({
    content: {
        id: "suggestion.39.madlib.content",
        defaultMessage:
            "Data lake migration with the goal of centralizing datasets",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.39.madlib.task",
        defaultMessage: "data lake migration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.39.madlib.goal",
        defaultMessage: "centralizing datasets",
        description: "The goal for the suggestion"
    }
});

export const suggestion40Messages = defineMessages({
    content: {
        id: "suggestion.40.madlib.content",
        defaultMessage:
            "Funnel analysis with the goal of identifying new opportunities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.40.madlib.task",
        defaultMessage: "funnel analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.40.madlib.goal",
        defaultMessage: "identifying new opportunities",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => SALES
export const suggestion41Messages = defineMessages({
    content: {
        id: "suggestion.41.madlib.content",
        defaultMessage:
            "Lead generation project with the goal of finding new customers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.41.madlib.task",
        defaultMessage: "lead generation project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.41.madlib.goal",
        defaultMessage: "finding new customers",
        description: "The goal for the suggestion"
    }
});

export const suggestion42Messages = defineMessages({
    content: {
        id: "suggestion.42.madlib.content",
        defaultMessage: "Sales campaign with the goal of increasing revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.42.madlib.task",
        defaultMessage: "sales campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.42.madlib.goal",
        defaultMessage: "increasing revenue",
        description: "The goal for the suggestion"
    }
});

export const suggestion43Messages = defineMessages({
    content: {
        id: "suggestion.43.madlib.content",
        defaultMessage:
            "Account plan with the goal of growing client relationships",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.43.madlib.task",
        defaultMessage: "account plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.43.madlib.goal",
        defaultMessage: "growing client relationships",
        description: "The goal for the suggestion"
    }
});

export const suggestion44Messages = defineMessages({
    content: {
        id: "suggestion.44.madlib.content",
        defaultMessage:
            "Sales kickoff plan with the goal of driving sales growth",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.44.madlib.task",
        defaultMessage: "sales kickoff plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.44.madlib.goal",
        defaultMessage: "driving sales growth",
        description: "The goal for the suggestion"
    }
});

export const suggestion45Messages = defineMessages({
    content: {
        id: "suggestion.45.madlib.content",
        defaultMessage:
            "Pipeline optimization with the goal of increasing deal flow",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.45.madlib.task",
        defaultMessage: "pipeline optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.45.madlib.goal",
        defaultMessage: "increasing deal flow",
        description: "The goal for the suggestion"
    }
});

export const suggestion46Messages = defineMessages({
    content: {
        id: "suggestion.46.madlib.content",
        defaultMessage:
            "Sales training program with the goal of improving team skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.46.madlib.task",
        defaultMessage: "sales training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.46.madlib.goal",
        defaultMessage: "improving team skills",
        description: "The goal for the suggestion"
    }
});

export const suggestion47Messages = defineMessages({
    content: {
        id: "suggestion.47.madlib.content",
        defaultMessage:
            "Market analysis with the goal of identifying new opportunities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.47.madlib.task",
        defaultMessage: "market analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.47.madlib.goal",
        defaultMessage: "identifying new opportunities",
        description: "The goal for the suggestion"
    }
});

export const suggestion48Messages = defineMessages({
    content: {
        id: "suggestion.48.madlib.content",
        defaultMessage:
            "Customer retention initiative with the goal of reducing churn",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.48.madlib.task",
        defaultMessage: "customer retention initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.48.madlib.goal",
        defaultMessage: "reducing churn",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => FINANCE
export const suggestion49Messages = defineMessages({
    content: {
        id: "suggestion.49.madlib.content",
        defaultMessage:
            "Annual budget plan with the goal of optimizing resource allocation",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.49.madlib.task",
        defaultMessage: "annual budget plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.49.madlib.goal",
        defaultMessage: "optimizing resource allocation",
        description: "The goal for the suggestion"
    }
});

export const suggestion50Messages = defineMessages({
    content: {
        id: "suggestion.50.madlib.content",
        defaultMessage:
            "Financial dashboard with the goal of surfacing key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.50.madlib.task",
        defaultMessage: "financial dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.50.madlib.goal",
        defaultMessage: "surfacing key metrics",
        description: "The goal for the suggestion"
    }
});

export const suggestion51Messages = defineMessages({
    content: {
        id: "suggestion.51.madlib.content",
        defaultMessage:
            "Financial audit preparation with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.51.madlib.task",
        defaultMessage: "financial audit preparation",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.51.madlib.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});

export const suggestion52Messages = defineMessages({
    content: {
        id: "suggestion.52.madlib.content",
        defaultMessage:
            "Cost reduction project with the goal of improving profitability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.52.madlib.task",
        defaultMessage: "cost reduction project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.52.madlib.goal",
        defaultMessage: "improving profitability",
        description: "The goal for the suggestion"
    }
});

export const suggestion53Messages = defineMessages({
    content: {
        id: "suggestion.53.madlib.content",
        defaultMessage:
            "Forecasting project with the goal of predicting revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.53.madlib.task",
        defaultMessage: "forecasting project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.53.madlib.goal",
        defaultMessage: "predicting revenue",
        description: "The goal for the suggestion"
    }
});

export const suggestion54Messages = defineMessages({
    content: {
        id: "suggestion.54.madlib.content",
        defaultMessage:
            "Automation project with the goal of streamlining operations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.54.madlib.task",
        defaultMessage: "automation project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.54.madlib.goal",
        defaultMessage: "streamlining operations",
        description: "The goal for the suggestion"
    }
});

export const suggestion55Messages = defineMessages({
    content: {
        id: "suggestion.55.madlib.content",
        defaultMessage:
            "Technology upgrade with the goal of modernizing our systems",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.55.madlib.task",
        defaultMessage: "technology upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.55.madlib.goal",
        defaultMessage: "modernizing our systems",
        description: "The goal for the suggestion"
    }
});

export const suggestion56Messages = defineMessages({
    content: {
        id: "suggestion.56.madlib.content",
        defaultMessage:
            "Tax planning initiative with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.56.madlib.task",
        defaultMessage: "tax planning initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.56.madlib.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => LEGAL
export const suggestion57Messages = defineMessages({
    content: {
        id: "suggestion.57.madlib.content",
        defaultMessage:
            "Contract review project with the goal of faster approvals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.57.madlib.task",
        defaultMessage: "contract review project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.57.madlib.goal",
        defaultMessage: "faster approvals",
        description: "The goal for the suggestion"
    }
});

export const suggestion58Messages = defineMessages({
    content: {
        id: "suggestion.58.madlib.content",
        defaultMessage:
            "Compliance rollout with the goal of meeting regulatory standards",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.58.madlib.task",
        defaultMessage: "compliance rollout",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.58.madlib.goal",
        defaultMessage: "meeting regulatory standards",
        description: "The goal for the suggestion"
    }
});

export const suggestion59Messages = defineMessages({
    content: {
        id: "suggestion.59.madlib.content",
        defaultMessage:
            "Property transaction with the goal of finalizing a deal",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.59.madlib.task",
        defaultMessage: "property transaction",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.59.madlib.goal",
        defaultMessage: "finalizing a deal",
        description: "The goal for the suggestion"
    }
});

export const suggestion60Messages = defineMessages({
    content: {
        id: "suggestion.60.madlib.content",
        defaultMessage:
            "IP litigation case with the goal of protecting intellectual property",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.60.madlib.task",
        defaultMessage: "ip litigation case",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.60.madlib.goal",
        defaultMessage: "protecting intellectual property",
        description: "The goal for the suggestion"
    }
});

export const suggestion61Messages = defineMessages({
    content: {
        id: "suggestion.61.madlib.content",
        defaultMessage:
            "Legal intake portal with the goal of streamlining request handling",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.61.madlib.task",
        defaultMessage: "legal intake portal",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.61.madlib.goal",
        defaultMessage: "streamlining request handling",
        description: "The goal for the suggestion"
    }
});

export const suggestion62Messages = defineMessages({
    content: {
        id: "suggestion.62.madlib.content",
        defaultMessage:
            "Data privacy project with the goal of protecting customer data",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.62.madlib.task",
        defaultMessage: "data privacy project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.62.madlib.goal",
        defaultMessage: "protecting customer data",
        description: "The goal for the suggestion"
    }
});

export const suggestion63Messages = defineMessages({
    content: {
        id: "suggestion.63.madlib.content",
        defaultMessage:
            "Employee policy review with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.63.madlib.task",
        defaultMessage: "employee policy review",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.63.madlib.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});

export const suggestion64Messages = defineMessages({
    content: {
        id: "suggestion.64.madlib.content",
        defaultMessage:
            "Legal tech adoption plan with the goal of improving team efficiency",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.64.madlib.task",
        defaultMessage: "legal tech adoption plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.64.madlib.goal",
        defaultMessage: "improving team efficiency",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => CUSTOMER SERVICE
export const suggestion65Messages = defineMessages({
    content: {
        id: "suggestion.65.madlib.content",
        defaultMessage: "Support project with the goal of monitoring requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.65.madlib.task",
        defaultMessage: "support project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.65.madlib.goal",
        defaultMessage: "monitoring requests",
        description: "The goal for the suggestion"
    }
});

export const suggestion66Messages = defineMessages({
    content: {
        id: "suggestion.66.madlib.content",
        defaultMessage:
            "Knowledge base redesign with the goal of simplifying resources",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.66.madlib.task",
        defaultMessage: "knowledge base redesign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.66.madlib.goal",
        defaultMessage: "simplifying resources",
        description: "The goal for the suggestion"
    }
});

export const suggestion67Messages = defineMessages({
    content: {
        id: "suggestion.67.madlib.content",
        defaultMessage: "AI chat tool with the goal of automating responses",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.67.madlib.task",
        defaultMessage: "ai chat tool",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.67.madlib.goal",
        defaultMessage: "automating responses",
        description: "The goal for the suggestion"
    }
});

export const suggestion68Messages = defineMessages({
    content: {
        id: "suggestion.68.madlib.content",
        defaultMessage:
            "Customer feedback survey with the goal of gathering insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.68.madlib.task",
        defaultMessage: "customer feedback survey",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.68.madlib.goal",
        defaultMessage: "gathering insights",
        description: "The goal for the suggestion"
    }
});

export const suggestion69Messages = defineMessages({
    content: {
        id: "suggestion.69.madlib.content",
        defaultMessage:
            "Process optimization with the goal of reducing bottlenecks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.69.madlib.task",
        defaultMessage: "process optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.69.madlib.goal",
        defaultMessage: "reducing bottlenecks",
        description: "The goal for the suggestion"
    }
});

export const suggestion70Messages = defineMessages({
    content: {
        id: "suggestion.70.madlib.content",
        defaultMessage:
            "Multi-channel integration with the goal of centralizing interactions",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.70.madlib.task",
        defaultMessage: "multi-channel integration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.70.madlib.goal",
        defaultMessage: "centralizing interactions",
        description: "The goal for the suggestion"
    }
});

export const suggestion71Messages = defineMessages({
    content: {
        id: "suggestion.71.madlib.content",
        defaultMessage:
            "Support dashboard with the goal of tracking key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.71.madlib.task",
        defaultMessage: "support dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.71.madlib.goal",
        defaultMessage: "tracking key metrics",
        description: "The goal for the suggestion"
    }
});

export const suggestion72Messages = defineMessages({
    content: {
        id: "suggestion.72.madlib.content",
        defaultMessage:
            "Training program with the goal of improving team skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.72.madlib.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.72.madlib.goal",
        defaultMessage: "improving team skills",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => HUMAN RESOURCES
export const suggestion73Messages = defineMessages({
    content: {
        id: "suggestion.73.madlib.content",
        defaultMessage:
            "New hire onboarding with the goal of ramping up employees",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.73.madlib.task",
        defaultMessage: "new hire onboarding",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.73.madlib.goal",
        defaultMessage: "ramping up employees",
        description: "The goal for the suggestion"
    }
});

export const suggestion74Messages = defineMessages({
    content: {
        id: "suggestion.74.madlib.content",
        defaultMessage: "Employee training with the goal of building skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.74.madlib.task",
        defaultMessage: "employee training",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.74.madlib.goal",
        defaultMessage: "building skills",
        description: "The goal for the suggestion"
    }
});

export const suggestion75Messages = defineMessages({
    content: {
        id: "suggestion.75.madlib.content",
        defaultMessage:
            "Performance review process with the goal of evaluating growth",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.75.madlib.task",
        defaultMessage: "performance review process",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.75.madlib.goal",
        defaultMessage: "evaluating growth",
        description: "The goal for the suggestion"
    }
});

export const suggestion76Messages = defineMessages({
    content: {
        id: "suggestion.76.madlib.content",
        defaultMessage:
            "Benefits rollout with the goal of improving employee satisfaction",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.76.madlib.task",
        defaultMessage: "benefits rollout",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.76.madlib.goal",
        defaultMessage: "improving employee satisfaction",
        description: "The goal for the suggestion"
    }
});

export const suggestion77Messages = defineMessages({
    content: {
        id: "suggestion.77.madlib.content",
        defaultMessage:
            "Recruitment campaign with the goal of hiring top talent",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.77.madlib.task",
        defaultMessage: "recruitment campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.77.madlib.goal",
        defaultMessage: "hiring top talent",
        description: "The goal for the suggestion"
    }
});

export const suggestion78Messages = defineMessages({
    content: {
        id: "suggestion.78.madlib.content",
        defaultMessage: "Employee survey with the goal of gathering feedback",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.78.madlib.task",
        defaultMessage: "employee survey",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.78.madlib.goal",
        defaultMessage: "gathering feedback",
        description: "The goal for the suggestion"
    }
});

export const suggestion79Messages = defineMessages({
    content: {
        id: "suggestion.79.madlib.content",
        defaultMessage: "Compliance audit with the goal of meeting regulations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.79.madlib.task",
        defaultMessage: "compliance audit",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.79.madlib.goal",
        defaultMessage: "meeting regulations",
        description: "The goal for the suggestion"
    }
});

export const suggestion80Messages = defineMessages({
    content: {
        id: "suggestion.80.madlib.content",
        defaultMessage:
            "Campus hiring program with the goal of recruiting new graduates",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.80.madlib.task",
        defaultMessage: "campus hiring program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.80.madlib.goal",
        defaultMessage: "recruiting new graduates",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => IT SUPPORT
export const suggestion81Messages = defineMessages({
    content: {
        id: "suggestion.81.madlib.content",
        defaultMessage:
            "Knowledge base with the goal of speeding up troubleshooting",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.81.madlib.task",
        defaultMessage: "knowledge base",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.81.madlib.goal",
        defaultMessage: "speeding up troubleshooting",
        description: "The goal for the suggestion"
    }
});

export const suggestion82Messages = defineMessages({
    content: {
        id: "suggestion.82.madlib.content",
        defaultMessage: "Support workflow with the goal of managing requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.82.madlib.task",
        defaultMessage: "support workflow",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.82.madlib.goal",
        defaultMessage: "managing requests",
        description: "The goal for the suggestion"
    }
});

export const suggestion83Messages = defineMessages({
    content: {
        id: "suggestion.83.madlib.content",
        defaultMessage:
            "Asset management project with the goal of tracking hardware",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.83.madlib.task",
        defaultMessage: "asset management project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.83.madlib.goal",
        defaultMessage: "tracking hardware",
        description: "The goal for the suggestion"
    }
});

export const suggestion84Messages = defineMessages({
    content: {
        id: "suggestion.84.madlib.content",
        defaultMessage:
            "Backup and recovery plan with the goal of protecting data",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.84.madlib.task",
        defaultMessage: "backup and recovery plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.84.madlib.goal",
        defaultMessage: "protecting data",
        description: "The goal for the suggestion"
    }
});

export const suggestion85Messages = defineMessages({
    content: {
        id: "suggestion.85.madlib.content",
        defaultMessage:
            "Training program with the goal of reducing support requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.85.madlib.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.85.madlib.goal",
        defaultMessage: "reducing support requests",
        description: "The goal for the suggestion"
    }
});

export const suggestion86Messages = defineMessages({
    content: {
        id: "suggestion.86.madlib.content",
        defaultMessage:
            "Vendor procurement project with the goal of managing suppliers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.86.madlib.task",
        defaultMessage: "vendor procurement project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.86.madlib.goal",
        defaultMessage: "managing suppliers",
        description: "The goal for the suggestion"
    }
});

export const suggestion87Messages = defineMessages({
    content: {
        id: "suggestion.87.madlib.content",
        defaultMessage: "System upgrade with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.87.madlib.task",
        defaultMessage: "system upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.87.madlib.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});

export const suggestion88Messages = defineMessages({
    content: {
        id: "suggestion.88.madlib.content",
        defaultMessage:
            "Dashboard with the goal of tracking system performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.88.madlib.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.88.madlib.goal",
        defaultMessage: "tracking system performance",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => OPERATIONS
export const suggestion89Messages = defineMessages({
    content: {
        id: "suggestion.89.madlib.content",
        defaultMessage:
            "Process update initiative with the goal of optimizing workflows",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.89.madlib.task",
        defaultMessage: "process update initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.89.madlib.goal",
        defaultMessage: "optimizing workflows",
        description: "The goal for the suggestion"
    }
});

export const suggestion90Messages = defineMessages({
    content: {
        id: "suggestion.90.madlib.content",
        defaultMessage:
            "Dashboard with the goal of providing actionable insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.90.madlib.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.90.madlib.goal",
        defaultMessage: "providing actionable insights",
        description: "The goal for the suggestion"
    }
});

export const suggestion91Messages = defineMessages({
    content: {
        id: "suggestion.91.madlib.content",
        defaultMessage:
            "Inventory overhaul with the goal of improving stock management",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.91.madlib.task",
        defaultMessage: "inventory overhaul",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.91.madlib.goal",
        defaultMessage: "improving stock management",
        description: "The goal for the suggestion"
    }
});

export const suggestion92Messages = defineMessages({
    content: {
        id: "suggestion.92.madlib.content",
        defaultMessage:
            "Workflow update with the goal of improving team collaboration",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.92.madlib.task",
        defaultMessage: "workflow update",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.92.madlib.goal",
        defaultMessage: "improving team collaboration",
        description: "The goal for the suggestion"
    }
});

export const suggestion93Messages = defineMessages({
    content: {
        id: "suggestion.93.madlib.content",
        defaultMessage:
            "Vendor onboarding program with the goal of streamlining suppliers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.93.madlib.task",
        defaultMessage: "vendor onboarding program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.93.madlib.goal",
        defaultMessage: "streamlining suppliers",
        description: "The goal for the suggestion"
    }
});

export const suggestion94Messages = defineMessages({
    content: {
        id: "suggestion.94.madlib.content",
        defaultMessage:
            "Logistics plan with the goal of ensuring smooth operations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.94.madlib.task",
        defaultMessage: "logistics plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.94.madlib.goal",
        defaultMessage: "ensuring smooth operations",
        description: "The goal for the suggestion"
    }
});

export const suggestion95Messages = defineMessages({
    content: {
        id: "suggestion.95.madlib.content",
        defaultMessage: "Budget plan with the goal of controlling costs",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.95.madlib.task",
        defaultMessage: "budget plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.95.madlib.goal",
        defaultMessage: "controlling costs",
        description: "The goal for the suggestion"
    }
});

export const suggestion96Messages = defineMessages({
    content: {
        id: "suggestion.96.madlib.content",
        defaultMessage:
            "Process optimization project with the goal of reducing bottlenecks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.96.madlib.task",
        defaultMessage: "process optimization project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.96.madlib.goal",
        defaultMessage: "reducing bottlenecks",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => DESIGN
// TEAM TYPE => DESIGN
export const suggestion97Messages = defineMessages({
    content: {
        id: "suggestion.97.madlib.content",
        defaultMessage:
            "Product feature with the goal of improving the user experience",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.97.madlib.task",
        defaultMessage: "product feature",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.97.madlib.goal",
        defaultMessage: "improving the user experience",
        description: "The goal for the suggestion"
    }
});

export const suggestion98Messages = defineMessages({
    content: {
        id: "suggestion.98.madlib.content",
        defaultMessage:
            "Design system with the goal of scaling consistent components",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.98.madlib.task",
        defaultMessage: "design system",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.98.madlib.goal",
        defaultMessage: "scaling consistent components",
        description: "The goal for the suggestion"
    }
});

export const suggestion99Messages = defineMessages({
    content: {
        id: "suggestion.99.madlib.content",
        defaultMessage:
            "Website redesign with the goal of simplifying navigation",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.99.madlib.task",
        defaultMessage: "website redesign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.99.madlib.goal",
        defaultMessage: "simplifying navigation",
        description: "The goal for the suggestion"
    }
});

export const suggestion100Messages = defineMessages({
    content: {
        id: "suggestion.100.madlib.content",
        defaultMessage: "Brand refresh with the goal of unifying visuals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.100.madlib.task",
        defaultMessage: "brand refresh",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.100.madlib.goal",
        defaultMessage: "unifying visuals",
        description: "The goal for the suggestion"
    }
});

export const suggestion101Messages = defineMessages({
    content: {
        id: "suggestion.101.madlib.content",
        defaultMessage:
            "Interactive prototype with the goal of testing new concepts",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.101.madlib.task",
        defaultMessage: "interactive prototype",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.101.madlib.goal",
        defaultMessage: "testing new concepts",
        description: "The goal for the suggestion"
    }
});

export const suggestion102Messages = defineMessages({
    content: {
        id: "suggestion.102.madlib.content",
        defaultMessage:
            "Research study with the goal of validating design decisions",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.102.madlib.task",
        defaultMessage: "research study",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.102.madlib.goal",
        defaultMessage: "validating design decisions",
        description: "The goal for the suggestion"
    }
});

export const suggestion103Messages = defineMessages({
    content: {
        id: "suggestion.103.madlib.content",
        defaultMessage:
            "Content strategy with the goal of creating a consistent voice",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.103.madlib.task",
        defaultMessage: "content strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.103.madlib.goal",
        defaultMessage: "creating a consistent voice",
        description: "The goal for the suggestion"
    }
});

export const suggestion104Messages = defineMessages({
    content: {
        id: "suggestion.104.madlib.content",
        defaultMessage:
            "Mobile app design with the goal of streamlining core user flows",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.104.madlib.task",
        defaultMessage: "mobile app design",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.104.madlib.goal",
        defaultMessage: "streamlining core user flows",
        description: "The goal for the suggestion"
    }
});

// TEAM TYPE => PROJECT MANAGEMENT
export const suggestion105Messages = defineMessages({
    content: {
        id: "suggestion.105.madlib.content",
        defaultMessage:
            "Product release with the goal of keeping teams aligned",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.105.madlib.task",
        defaultMessage: "product release",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.105.madlib.goal",
        defaultMessage: "keeping teams aligned",
        description: "The goal for the suggestion"
    }
});

export const suggestion106Messages = defineMessages({
    content: {
        id: "suggestion.106.madlib.content",
        defaultMessage:
            "Project kickoff with the goal of aligning stakeholders",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.106.madlib.task",
        defaultMessage: "project kickoff",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.106.madlib.goal",
        defaultMessage: "aligning stakeholders",
        description: "The goal for the suggestion"
    }
});

export const suggestion107Messages = defineMessages({
    content: {
        id: "suggestion.107.madlib.content",
        defaultMessage:
            "Marketing launch with the goal of ensuring on-time delivery",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.107.madlib.task",
        defaultMessage: "marketing launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.107.madlib.goal",
        defaultMessage: "ensuring on-time delivery",
        description: "The goal for the suggestion"
    }
});

export const suggestion108Messages = defineMessages({
    content: {
        id: "suggestion.108.madlib.content",
        defaultMessage: "Resource plan with the goal of balancing workloads",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.108.madlib.task",
        defaultMessage: "resource plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.108.madlib.goal",
        defaultMessage: "balancing workloads",
        description: "The goal for the suggestion"
    }
});

export const suggestion109Messages = defineMessages({
    content: {
        id: "suggestion.109.madlib.content",
        defaultMessage:
            "Status report with the goal of keeping leadership informed",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.109.madlib.task",
        defaultMessage: "status report",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.109.madlib.goal",
        defaultMessage: "keeping leadership informed",
        description: "The goal for the suggestion"
    }
});

export const suggestion110Messages = defineMessages({
    content: {
        id: "suggestion.110.madlib.content",
        defaultMessage: "Timeline plan with the goal of meeting deadlines",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.110.madlib.task",
        defaultMessage: "timeline plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.110.madlib.goal",
        defaultMessage: "meeting deadlines",
        description: "The goal for the suggestion"
    }
});

export const suggestion111Messages = defineMessages({
    content: {
        id: "suggestion.111.madlib.content",
        defaultMessage:
            "Risk assessment with the goal of reducing project blockers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.111.madlib.task",
        defaultMessage: "risk assessment",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.111.madlib.goal",
        defaultMessage: "reducing project blockers",
        description: "The goal for the suggestion"
    }
});

export const suggestion112Messages = defineMessages({
    content: {
        id: "suggestion.112.madlib.content",
        defaultMessage:
            "Cross-functional project with the goal of coordinating team tasks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.112.madlib.task",
        defaultMessage: "cross-functional project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.112.madlib.goal",
        defaultMessage: "coordinating team tasks",
        description: "The goal for the suggestion"
    }
});

export const getSuggestionsForTeamType = (teamType: string) => {
    switch (teamType) {
        case USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
            return [
                suggestion1Message,
                suggestion2Message,
                suggestion3Messages,
                suggestion4Messages,
                suggestion5Messages,
                suggestion6Messages,
                suggestion7Messages,
                suggestion8Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
            return [
                suggestion9Messages,
                suggestion10Messages,
                suggestion11Messages,
                suggestion12Messages,
                suggestion13Messages,
                suggestion14Messages,
                suggestion15Messages,
                suggestion16Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_MARKETING:
            return [
                suggestion17Messages,
                suggestion18Messages,
                suggestion19Messages,
                suggestion20Messages,
                suggestion21Messages,
                suggestion22Messages,
                suggestion23Messages,
                suggestion24Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL:
            return [
                suggestion25Messages,
                suggestion26Messages,
                suggestion27Messages,
                suggestion28Messages,
                suggestion29Messages,
                suggestion30Messages,
                suggestion31Messages,
                suggestion32Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
            return [
                suggestion33Messages,
                suggestion34Messages,
                suggestion35Messages,
                suggestion36Messages,
                suggestion37Messages,
                suggestion38Messages,
                suggestion39Messages,
                suggestion40Messages
            ];

        case USER_SEGMENTATION_TEAM_TYPE_SALES:
            return [
                suggestion41Messages,
                suggestion42Messages,
                suggestion43Messages,
                suggestion44Messages,
                suggestion45Messages,
                suggestion46Messages,
                suggestion47Messages,
                suggestion48Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_FINANCE:
            return [
                suggestion49Messages,
                suggestion50Messages,
                suggestion51Messages,
                suggestion52Messages,
                suggestion53Messages,
                suggestion54Messages,
                suggestion55Messages,
                suggestion56Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_LEGAL:
            return [
                suggestion57Messages,
                suggestion58Messages,
                suggestion59Messages,
                suggestion60Messages,
                suggestion61Messages,
                suggestion62Messages,
                suggestion63Messages,
                suggestion64Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
            return [
                suggestion65Messages,
                suggestion66Messages,
                suggestion67Messages,
                suggestion68Messages,
                suggestion69Messages,
                suggestion70Messages,
                suggestion71Messages,
                suggestion72Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_HR:
            return [
                suggestion73Messages,
                suggestion74Messages,
                suggestion75Messages,
                suggestion76Messages,
                suggestion77Messages,
                suggestion78Messages,
                suggestion79Messages,
                suggestion80Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
            return [
                suggestion81Messages,
                suggestion82Messages,
                suggestion83Messages,
                suggestion84Messages,
                suggestion85Messages,
                suggestion86Messages,
                suggestion87Messages,
                suggestion88Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
            return [
                suggestion89Messages,
                suggestion90Messages,
                suggestion91Messages,
                suggestion92Messages,
                suggestion93Messages,
                suggestion94Messages,
                suggestion95Messages,
                suggestion96Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_DESIGN:
            return [
                suggestion97Messages,
                suggestion98Messages,
                suggestion99Messages,
                suggestion100Messages,
                suggestion101Messages,
                suggestion102Messages,
                suggestion103Messages,
                suggestion104Messages
            ];
        case USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
            return [
                suggestion105Messages,
                suggestion106Messages,
                suggestion107Messages,
                suggestion108Messages,
                suggestion109Messages,
                suggestion110Messages,
                suggestion111Messages,
                suggestion112Messages
            ];
        default:
            return [];
    }
};
